import React from "react";
import bg from "../../assets/image/tempbg2.png";
import icon from "../../assets/image/testicon2.png";
import { baseUrl } from "../../utils/base_url";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
  _450px,
} from "../../utils/mediaBreakpoints";

const InfrastructureAndOperationalControls = ({ data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  return (
    <>
      <div className="row  p-0 " style={{ background: "#1F46BE" }}>
        <div className="d-flex flex-column gap-4 p-0 position-relative">
          <img
            className=""
            src={`${baseUrl}${data?.background_image?.url}`}
            alt=""
            style={{
              opacity: "20%",
              objectFit: "cover",
              height: _576
                ? "80vh"
                : _768
                ? "55vh"
                : _992
                ? "60vh"
                : _1200
                ? "85vh"
                : _1400
                ? "90vh"
                : _1500
                ? "95vh"
                : _1600
                ? "110vh"
                : _1700
                ? "100vh"
                : _1800
                ? "100vh"
                : "100vh",
            }}
          />
          <div
            className="d-flex flex-column align-items-center w-100 position-absolute"
            style={{
              padding: _576
                ? "1rem 0rem 2rem  0rem"
                : _992
                ? "3rem 0rem 2rem  0rem"
                : _1400
                ? "5rem 0rem 2rem  0rem"
                : "7rem 0rem 2rem  0rem",
              gap: _450 ? "0.5rem" : _768 ? "4rem" : _1400 ? "6rem" : "9rem",
            }}
          >
            <div className="d-flex flex-column gap-lg-4 align-items-center text-center  ">
              <p
                className="fw900 text-white lh-sm"
                style={{
                  fontSize: _450
                    ? "25px"
                    : _576
                    ? "30px"
                    : _768
                    ? "30px"
                    : _992
                    ? "30px"
                    : _1200
                    ? "35px"
                    : _1400
                    ? "45px"
                    : _1600
                    ? "55px"
                    : _1700
                    ? "60px"
                    : _1800
                    ? "70px"
                    : "70px",
                  // lineHeight: _450
                  //   ? "23px"
                  //   : _576
                  //   ? "30px"
                  //   : _768
                  //   ? "30px"
                  //   : _992
                  //   ? "36px"
                  //   : _1200
                  //   ? "48px"
                  //   : _1400
                  //   ? "54px"
                  //   : _1600
                  //   ? "60px"
                  //   : _1700
                  //   ? "66px"
                  //   : _1800
                  //   ? "70px"
                  //   : "70px",
                }}
                dangerouslySetInnerHTML={{
                  __html: data?.heading?.split("\n")?.join("<br/>"),
                }}
              />

              {data?.sub_heading &&
                (() => {
                  const phrase = "without compromising control";
                  return (
                    <p
                      className={`text-white lh-sm fw600 px-3 px-md-0`}
                      style={{
                        fontSize: _450
                          ? "15px"
                          : _576
                          ? "15px"
                          : _768
                          ? "14px"
                          : _992
                          ? "16px"
                          : _1200
                          ? "20px"
                          : _1400
                          ? "25px"
                          : _1600
                          ? "30px"
                          : _1700
                          ? "35px"
                          : _1800
                          ? "40px"
                          : "40px",
                        // lineHeight: _450
                        //   ? "0.7rem"
                        //   : _576
                        //   ? "1rem"
                        //   : _768
                        //   ? "1rem"
                        //   : _992
                        //   ? "1.3rem"
                        //   : _1200
                        //   ? "1.8rem"
                        //   : _1400
                        //   ? "1.9rem"
                        //   : _1600
                        //   ? "2rem"
                        //   : _1700
                        //   ? "2.2rem"
                        //   : _1800
                        //   ? "2.5rem"
                        //   : "2.5rem",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: _450
                          ? data?.sub_heading
                              ?.split("\n")
                              ?.join(" ")
                              ?.replace(
                                phrase,
                                `<span style="color: #459EFF">${phrase}</span>`
                              )
                          : data?.sub_heading
                              ?.split("\n")
                              ?.join("<br/>")
                              ?.replace(
                                phrase,
                                `<span style="color: #459EFF">${phrase}</span>`
                              ),
                      }}
                    />
                  );
                })()}
            </div>
            <div className="container contwidth">
              <div className={`row ${_992 ? "g-3" : "g-5"}`}>
                {data?.operations?.map((obj, index) => (
                  <div className="col-12 col-sm-6" key={index}>
                    <ControlsCard data={obj} index={index} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const ControlsCard = ({ data, index }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  console.log("key",index);
  
  return (
    <div
      className={`d-flex pt-3 pt-sm-0 ${!_576 && (index === 0 || index === 1)?"pb-3":""} ${_768 ? "gap-3" : "gap-5"}`}
      style={{
        borderBottom:
          !_576 && (index === 0 || index === 1) ? "1px solid white" : "",
      }}
    >
      <div className="align-self-start">
        <img
          src={`${baseUrl}${data?.icon?.url}`}
          alt=""
          width={
            _450
              ? 60
              : _576
              ? 60
              : _768
              ? 40
              : _992
              ? 45
              : _1200
              ? 50
              : _1400
              ? 55
              : _1600
              ? 63
              : _1700
              ? 65
              : _1800
              ? 73
              : 73
          }
        />
      </div>
      <p
        className="fw600 text-white align-self-center mb-0"
        style={{
          fontSize: _450
            ? "14px"
            : _576
            ? "14px"
            : _768
            ? "10px"
            : _992
            ? "14px"
            : _1200
            ? "16px"
            : _1400
            ? "18px"
            : _1600
            ? "20px"
            : _1700
            ? "25px"
            : _1800
            ? "30px"
            : "30px",
          // lineHeight: _576
          //   ? "14px"
          //   : _768
          //   ? "16px"
          //   : _992
          //   ? "20px"
          //   : _1200
          //   ? "25px"
          //   : _1400
          //   ? "34px"
          //   : _1600
          //   ? "36px"
          //   : _1700
          //   ? "36px"
          //   : _1800
          //   ? "36px"
          //   : "36px",
        }}
        dangerouslySetInnerHTML={{
          __html: data?.title?.split("\n")?.join("<br/>"),
        }}
      />
    </div>
  );
};

export default InfrastructureAndOperationalControls;
